import { put, all, fork, takeLatest, call } from 'redux-saga/effects';
import { getUpcomingWebinarsForDates } from 'Api/Webinar/webinarService';
import * as virtualEventDetailsService from 'Api/VirtualEvent/VirtualEventDetails/VirtualEventDetailsService';
import { getEventsForDatesAction, getVirtualEventsForDatesAction } from './actions';

export function* fetchEvents({ startDate, endDate }) {
  try {
    const data = yield call(getUpcomingWebinarsForDates, startDate, endDate);

    yield put({ type: getEventsForDatesAction.complete.toString(), data });
  } catch (e) {
    yield put({ type: getEventsForDatesAction.failed.toString(), message: e.message });
  }
}

export function* fetchVirtualEvents({ startDate, endDate }) {
  try {
    const data = yield call(virtualEventDetailsService.getVirtualEvents, { timeRangeFrom: startDate, timeRangeTo: endDate });
    yield put({ type: getVirtualEventsForDatesAction.complete.toString(), data });
  } catch (e) {
    yield put({ type: getVirtualEventsForDatesAction.failed.toString(), message: e.message });
  }
}

// ------------------------------------ WATCHERS -----------------------------------
export function* watchGetEvents() {
  yield takeLatest(getEventsForDatesAction.toString(), fetchEvents);
}

export function* watchGetVirtualEvents() {
  yield takeLatest(getVirtualEventsForDatesAction.toString(), fetchVirtualEvents);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetEvents),
    fork(watchGetVirtualEvents)
  ]);
}
